import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import styled from 'styled-components';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import IndustryCard from '../components/IndustryCard';

// Import images from the available images
import heroImage from '../assets/images/Home/HomeBanner.webp';
import industryImg1 from '../assets/images/Home/Img1.webp';
import industryImg2 from '../assets/images/Home/Img2.webp';
import industryImg3 from '../assets/images/Home/Img3.webp';
import industryImg4 from '../assets/images/Home/Img4.webp';

const SectionTitle = styled.h2`
  font-size: 40px;
  font-weight: 500;
  margin-bottom: 0;
  text-align: center;
  line-height: 1.2;
  
  .dark {
    color: #333;
  }
  
  .highlight {
    color: #e4880f;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 16px;
  letter-spacing: 1px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  color: #555;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 0;
`;

const Divider = styled.div`
  width: 120px;
  height: 3px;
  background-color: #e4880f;
  margin: 10px auto 25px;
`;

const SectionDescription = styled.p`
  font-size: 16px;
  font-family: 'Montserrat', sans-serif;
  line-height: 1.6;
  color: #555;
  text-align: center;
`;

const Home = () => {
  // Industry data
  const industries = [
    {
      id: 1,
      title: 'Industrial Manufacturing',
      image: industryImg1
    },
    {
      id: 2,
      title: 'Custom Fabrication',
      image: industryImg2
    },
    {
      id: 3,
      title: 'Engineering & Prototyping',
      image: industryImg3
    },
    {
      id: 4,
      title: 'Construction & Architecture',
      image: industryImg4
    }
  ];

  return (
    <>
      <Hero 
        backgroundImage={heroImage}
        title="Precision Cutting & Engineering You Can Rely On"
        subtitle="FABXPERT"
        description="FabXpert combines technology and expertise to provide high-quality cutting services. Whether for small custom projects or large-scale manufacturing, we guarantee accuracy, efficiency, and a commitment to excellence."
      />

      {/* Our Services Section */}
      <div className="pt-3 pb-5 mb-md-4">
        <ServicesSection />
      </div>

      <section className="pb-5 mb-md-4">
        <Container>
          <div className="text-center">
            <SectionTitle>
              <span className="dark">Serving Industries </span>
              <span className="highlight">That Demand Perfection</span>
            </SectionTitle>
            <SectionSubtitle>
              YOUR GO-TO EXPERTS FOR PRECISION CUTTING & FABRICATION
            </SectionSubtitle>
            <Divider />
          </div>
          <Row>
            <Col lg={10} className="mx-auto">
              <SectionDescription>
                FabXpert provides precision-cutting solutions for industries where accuracy, reliability, and quality are essential. Whether it's intricate 
                architectural designs, high-performance aerospace components, or durable parts for manufacturing, our cutting technology ensures 
                exceptional results.
              </SectionDescription>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pb-5 mb-md-4">
        <Container>
          <div className="text-center mb-5">
            <SectionTitle>
              <span className="dark">Industries </span>
              <span className="highlight">We Serve:</span>
            </SectionTitle>
          </div>
          <Row className="g-4">
            {industries.map(industry => (
              <Col lg={3} md={6} key={industry.id}>
                <IndustryCard 
                  title={industry.title}
                  image={industry.image}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="pb-5 mb-md-4">
        <Container className="text-center">
          <SectionTitle className="mb-0">
            <span className="dark" style={{ color: '#333' }}>Start Your Project </span>
            <span className="highlight">With FabXpert</span>
          </SectionTitle>
          <SectionSubtitle style={{ color: '#555', marginTop: '10px', marginBottom: '10px' }}>
            YOUR CUTTING NEEDS, OUR EXPERT SOLUTIONS
          </SectionSubtitle>
          <div style={{ 
            width: '120px', 
            height: '3px', 
            backgroundColor: '#e4880f', 
            margin: '10px auto 30px' 
          }}></div>
          
          <p style={{ 
            fontSize: '16px', 
            fontFamily: 'Montserrat, sans-serif', 
            lineHeight: '1.6', 
            color: '#555', 
            maxWidth: '800px', 
            margin: '0 auto 10px' 
          }}>
            Looking for reliable cutting and engineering solutions?<br />
            Contact us today for a consultation or request a quote!
          </p>
          
          <button 
            style={{ 
              backgroundColor: 'white',
              border: '3px solid #e4880f',
              color: '#333',
              padding: '12px 45px',
              fontWeight: '500',
              letterSpacing: '1px',
              borderRadius: '0',
              fontSize: '14px',
              transition: 'all 0.3s ease',
              boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.2)'
            }}
            className="contact-btn"
            onClick={() => window.location.href='mailto:info@fabxpert.com'}
          >
            CONTACT US
          </button>
        </Container>
      </section>
    </>
  );
};

export default Home; 